import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { GetCompanyInformationResponse, HttpResponse } from "@/types";

export function useGetCompanyInformation() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["company_information", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/company-information`;
      const res = await httpClient.get<
        GetCompanyInformationResponse,
        HttpResponse<GetCompanyInformationResponse>
      >(path);
      return res.data;
    },
  });
}
